// extracted by mini-css-extract-plugin
export default {"container":"Part2_container__cReOZ","leftSide":"Part2_leftSide__ECQx1","rightSide":"Part2_rightSide__4QAlB"};